import React, { useEffect } from "react";

/**
 * Shared in-app confirmation modal. Replaces window.confirm() which is
 * blocked inside sandbox iframes (like the Emergent preview). Also used
 * for any destructive actions (lead delete, task delete, status delete…).
 */
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Bevestigen",
  cancelLabel = "Annuleren",
  danger = false,
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onCancel?.();
      if (e.key === "Enter") onConfirm?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onCancel, onConfirm]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
         onClick={onCancel}
         data-testid="confirm-dialog">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-5"
           onClick={(e) => e.stopPropagation()}>
        <h3 className="font-display text-[20px] mb-2">{title}</h3>
        {typeof message === "string"
          ? <p className="text-[14px] text-[var(--ink-700)] mb-5 whitespace-pre-line">{message}</p>
          : <div className="text-[14px] text-[var(--ink-700)] mb-5">{message}</div>}
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onCancel}
                  data-testid="confirm-cancel"
                  className="btn !h-10 !px-4 bg-white hover:bg-[var(--sand-50)] text-[var(--ink-700)]">
            {cancelLabel}
          </button>
          <button type="button" onClick={onConfirm}
                  data-testid="confirm-ok"
                  className={`btn !h-10 !px-4 text-white border-transparent ${
                    danger ? "bg-[#B43232] hover:bg-[#992020]" : "bg-[var(--teal-700)] hover:bg-[var(--teal-800)]"
                  }`}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
